import React from 'react';
import './App.css';
import Login from './Components/Pages/Login';
import Signup from './Components/Pages/Signup';
import NavBar from './Components/Include/NavBar.js';
import Home from './Components/Pages/Home';
import Surveys from './Components/Pages/Surveys';
import Scoreboard from './Components/Pages/Scoreboard';
import 'bootstrap/dist/css/bootstrap.min.css';
import VenezuelaSection from './Components/Pages/Dropdown Pages/Venezuela.js';
import CanadaSection from './Components/Pages/Dropdown Pages/Canada.js';
import ChinaSection from './Components/Pages/Dropdown Pages/China.js';
import PhillipinesSection from './Components/Pages/Dropdown Pages/Phillipines.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext.js';
import Footer from './Components/Include/Footer';
import FeedbackForm from './Components/Pages/FeedbackForm.js';
import FilteredSurvey from './Components/Pages/FilteredSurvey'; 
import CanadaSurvey from './Components/Pages/CanadaSurvey'; 
import ChinaSurvey from './Components/Pages/ChinaSurvey'; 
import PhilippinesSurvey from './Components/Pages/PhilippinesSurvey'; 
import VenezuelaSurvey from './Components/Pages/VenezuelaSurvey'; 

function App() {
  return (
    <AuthProvider>
      <Router>
        <NavBar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/surveys" element={<Surveys />} />
            <Route path="/scoreboard" element={<Scoreboard />} />
            <Route path="/CanadaSection" element={<CanadaSection />} />
            <Route path="/ChinaSection" element={<ChinaSection />} />
            <Route path="/PhillipinesSection" element={<PhillipinesSection />} />
            <Route path="/VenezuelaSection" element={<VenezuelaSection />} />
            <Route path="/surveys" element={<Surveys />} />
            <Route path="/scoreboard" element={<Scoreboard />} />
            <Route path="/FeedbackForm" element={<FeedbackForm />} />
            <Route path="/filtered-surveys/:country/:category/:difficulty" element={<FilteredSurvey />} />
            <Route path="/surveys/practice/canada" element={<CanadaSurvey />} />
            <Route path="/surveys/practice/china" element={<ChinaSurvey />} />
            <Route path="/surveys/practice/philippines" element={<PhilippinesSurvey />} />
            <Route path="/surveys/practice/venezuela" element={<VenezuelaSurvey />} />
            {/* Protected routes with NavBar */}
            {ProtectedRoutes()}
          </Routes>
        </main>
        <Footer />
      </Router>
    </AuthProvider>
  );
}

// Define a separate component for routes that require authentication
function ProtectedRoutes() {
  return (
    <>
      {/* Render the NavBar only for routes except login and signup */}
      <Route
        path="/"
        element={
          <Route
            path="/"
            element={
              <>
                <NavBar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/surveys" element={<Surveys />} />
                  <Route path="/scoreboard" element={<Scoreboard />} />
                  <Route path="/CanadaSection" element={<CanadaSection />} />
                  <Route path="/ChinaSection" element={<ChinaSection />} />
                  <Route path="/PhillipinesSection" element={<PhillipinesSection />} />
                  <Route path="/VenezuelaSection" element={<VenezuelaSection />} />
                  <Route path="/FeedbackForm" element={<FeedbackForm />} />
                </Routes>
                <Footer />
              </>
            }
          />
        }
      />
    </>
  );
}

export default App;
